export function reloadApp() {
	window.location.reload();
}
